



















import Vue from 'vue';
import { Role } from '../types';

export default Vue.extend({
  props: {
    role: {
      type: Object as () => Role,
      required: true,
    },
    isEnabled: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle(isEnabled: boolean) {
      const eventName = isEnabled ? 'enabled' : 'disabled';
      this.$emit(eventName, this.role);
    },
  },
});
